import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { resolvePageId } from '@rebuild/utils/context';

export const useQuestionModuleData = () => {
	const { question } = useModuleData();

	const fetchQuestionList = async params => {
		const { pageId, ...restParams } = params || {};
		const finalPageId = pageId || resolvePageId();

		await question.refresh({
			...restParams,
			pageId: finalPageId
		});

		const data = question.data || {};
		return {
			rows: data.rows || [],
			total: data.total || 0,
			rawData: data
		};
	};

	return {
		question,
		fetchQuestionList
	};
};
